module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/缺省插图-找不到页面.e7e20.png";